var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18855 3.32135H4.07071C2.3748 3.32135 1 4.72157 1 6.44882V16.8738C1 18.6011 2.3748 20.0013 4.07071 20.0013H14.3064C16.0023 20.0013 17.3771 18.6011 17.3771 16.8738L17.3771 11.6613M6.11784 14.7888L9.84192 14.0245C10.0396 13.9839 10.2211 13.8848 10.3637 13.7395L18.7004 5.24404C19.1001 4.83672 19.0998 4.17649 18.6998 3.76952L16.9338 1.97289C16.5339 1.56609 15.886 1.56636 15.4864 1.97351L7.14889 10.4699C7.0066 10.6149 6.90944 10.7994 6.86957 11.0003L6.11784 14.7888Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlack);
export default __webpack_public_path__ + "static/media/edit_black.3e2145d41ebb04db86e23d61bb332b46.svg";
export { ForwardRef as ReactComponent };